import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SiteLayout from '@/components/feature/SiteLayout';
import { leagueMeta, leagueOrder, setPageMeta } from '@/lib/site';

export default function NotFound() {
  useEffect(() => {
    setPageMeta('页面未找到 - 篮球直播', '您访问的页面不存在，可返回篮球直播首页继续浏览 NBA、CBA 与国际篮球赛事直播。');
  }, []);

  return (
    <SiteLayout>
      <div className="w-full px-4 md:px-6 lg:px-8 py-16 md:py-24">
        <div className="max-w-xl mx-auto text-center">
          <p className="font-heading text-6xl md:text-7xl text-background-300 leading-none">404</p>
          <h1 className="mt-3 font-heading text-2xl text-foreground-950">这场球没找到</h1>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            你访问的页面可能已经结束或不存在。可以返回首页，或从下方联赛入口继续寻找想看的比赛。
          </p>
          <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 rounded-md bg-accent-500 px-4 py-2.5 text-sm font-medium text-background-50 hover:bg-accent-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-home-4-line" />
              返回首页
            </Link>
            <Link
              to="/search"
              className="inline-flex items-center gap-2 rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-search-line" />
              搜索赛事
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-3 gap-2">
            {leagueOrder.map((key) => (
              <Link
                key={key}
                to={`/category/${key}`}
                className="rounded-md bg-background-50 border border-background-200 py-3 text-xs text-foreground-800 hover:border-primary-300 transition-colors"
              >
                {leagueMeta[key].name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}